import './Control.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var expandButton = _7a468({defaultClassName:'_uoyq2d0-3-5-0',variantClassNames:{isFocusVisible:{true:'_uoyq2d1-3-5-0',false:'_uoyq2d2-3-5-0'}},defaultVariants:{},compoundVariants:[]});